import * as React from 'react';
import { getCanonicalUrl, LocationDetailedParsed } from './utils';
import { Search } from '@weddingspot/ws-api-client';
import { Link } from 'react-router-dom';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

const _styles = require('./Breadcrumbs.scss');

interface BreadCrumbProps {
    variant?: 'affordable' | 'rd';
    page?: number;
    location: LocationDetailedParsed;
    styleName?: string;
    styleUrlName?: string;
    zipcode?: string;
}

/**
 * Breadcrubm components @ the the top of the SRP page
 */
export default (props: BreadCrumbProps) => {
    const {
        variant: srpVariant,
        location: { market, region, subMarket },
        styleName,
        styleUrlName,
        zipcode,
    } = props;

    const isVanilla = !srpVariant;
    const isRd = srpVariant === 'rd';
    const isAffordable = srpVariant === 'affordable';
    const labelSuffix = isVanilla ? 'Wedding Venues' : isRd ? 'Rehearsal Dinners' : 'Affordable Venues';

    // Breadcrumb urls from left to right;
    const urls: { value: string; label: string }[] = [
        {
            label: 'Wedding Venues',
            value: getCanonicalUrl({}),
        },
    ];

    if (isRd || isAffordable) {
        urls.push({
            label: labelSuffix,
            value: getCanonicalUrl({ variant: srpVariant }),
        });
    }

    if (isRd || isVanilla) {
        if (zipcode) {
            if (market) {
                urls.push({
                    label: `${market} ${labelSuffix}`,
                    value: getCanonicalUrl({ variant: srpVariant, market }),
                });
            }

            urls.push({
                label: `${zipcode} ${labelSuffix}`,
                value: getCanonicalUrl({ variant: srpVariant, zipcode }),
            });
        } else if (styleName && styleUrlName) {
            if (market) {
                urls.push({
                    label: `${market} ${styleName} ${labelSuffix}`,
                    value: getCanonicalUrl({
                        variant: srpVariant,
                        styleUrlName: styleUrlName,
                        market,
                    }),
                });
            }
            if (subMarket) {
                urls.push({
                    label: `${subMarket} ${styleName} ${labelSuffix}`,
                    value: getCanonicalUrl({
                        variant: srpVariant,
                        styleUrlName: styleUrlName,
                        market,
                        submarket: subMarket,
                    }),
                });
            }
            if (region) {
                urls.push({
                    label: `${region} ${styleName} ${labelSuffix}`,
                    value: getCanonicalUrl({
                        variant: srpVariant,
                        styleUrlName: styleUrlName,
                        market,
                        region,
                    }),
                });
            }
        } else {
            if (market) {
                urls.push({
                    label: `${market} ${labelSuffix}`,
                    value: getCanonicalUrl({
                        variant: srpVariant,
                        market,
                    }),
                });
            }
            if (subMarket) {
                urls.push({
                    label: `${subMarket} ${labelSuffix}`,
                    value: getCanonicalUrl({
                        variant: srpVariant,
                        styleUrlName: styleUrlName,
                        market,
                        submarket: subMarket,
                    }),
                });
            }
            if (region) {
                urls.push({
                    label: `${region} ${labelSuffix}`,
                    value: getCanonicalUrl({
                        variant: srpVariant,
                        market,
                        region,
                    }),
                });
            }
        }
    }

    if (isAffordable) {
        if (market) {
            urls.push({
                label: `${market} ${labelSuffix}`,
                value: getCanonicalUrl({
                    variant: srpVariant,
                    market,
                }),
            });
        }
        if (region) {
            urls.push({
                label: `${region} ${labelSuffix}`,
                value: getCanonicalUrl({
                    variant: srpVariant,
                    market,
                    region,
                }),
            });
        }
        if (subMarket) {
            urls.push({
                label: `${subMarket} ${styleName} ${labelSuffix}`,
                value: getCanonicalUrl({
                    variant: srpVariant,
                    styleUrlName: styleUrlName,
                    market,
                    submarket: subMarket,
                }),
            });
        }
    }

    return (
        <div className={_styles.wrapper}>
            {urls.map(({ value, label }, index) => {
                const isLast = index === urls.length - 1;
                return (
                    <React.Fragment key={index}>
                        <Link
                            className={_styles.link}
                            to={value}
                            onClick={() => logEvent(AnalyticsEvent.EVTNM_CLICKED_BREADCRUMB, { Source: 'SRP' })}
                        >
                            {label}
                        </Link>
                        {!isLast && <span className={_styles.delimeter}>/</span>}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
